declare namespace $ {

	export class $mol_icon_cube extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=cube.view.tree.d.ts.map